import { render } from "./Divider.vue?vue&type=template&id=ff7e85b0&scoped=true&ts=true"
import script from "./Divider.ts?vue&type=script&lang=ts&external"
export * from "./Divider.ts?vue&type=script&lang=ts&external"

import "./Divider.scss?vue&type=style&index=0&id=ff7e85b0&lang=scss&scoped=true&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff7e85b0"]])

export default __exports__